<script>
import vBase from './vBase'
import {vCollectionMixin} from 'crud-vue-core'


export default {
  name: 'v-collection',
  extends: vBase,
  mixins: [vCollectionMixin]
}
</script>

<style scoped>

</style>
